import React, { useEffect, useRef, useState } from 'react';

import { ContainedButton, OutlinedButton } from '../Buttons';
import Modal from '../Modal';
import styles from './CreateEmptyTimelineModal.module.scss';

type TCreateEmptyTimelineModal = {
  open: boolean;
  defaultName: string;
  loading: boolean;
  onClose: () => void;
  onCreate: (name: string) => void | Promise<void>;
};

const CreateEmptyTimelineModal: React.FC<TCreateEmptyTimelineModal> = ({
  open,
  defaultName,
  loading,
  onClose,
  onCreate,
}) => {
  const [name, setName] = useState(defaultName);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!open) return;
    setName(defaultName);
    const rafId = requestAnimationFrame(() => inputRef.current?.select());
    return () => cancelAnimationFrame(rafId);
  }, [open, defaultName]);

  const closeModal = () => {
    if (!loading) onClose();
  };

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const trimmedName = name.trim();
    if (trimmedName && !loading) onCreate(trimmedName);
  };

  return (
    <Modal open={open} onClose={closeModal} loading={loading}>
      <form className={styles.modalBody} onSubmit={onSubmit}>
        <div className={styles.modalTitle}>Create Empty Timeline</div>
        <label className={styles.label} htmlFor="empty-timeline-name">
          Timeline name
        </label>
        <input
          ref={inputRef}
          id="empty-timeline-name"
          className={styles.input}
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={180}
          required
          autoFocus
        />
        <div className={styles.actionBtns}>
          <ContainedButton type="submit" disabled={!name.trim() || loading}>
            Create Timeline
          </ContainedButton>
          <OutlinedButton onClick={closeModal} disabled={loading}>
            Cancel
          </OutlinedButton>
        </div>
      </form>
    </Modal>
  );
};

export default CreateEmptyTimelineModal;
